import Loadable from 'my-components/Loadable';

export const MCAT = Loadable(() => import(/* webpackChunkName: "mcat-landing" */ './MCATCtnr'));
export const MCATFreeResources = Loadable(
  () => import(/* webpackChunkName: "mcat-free-resources" */ './MCATFreeResourcesCtnr'),
);
